import { devices } from '@helpers/utils.js';
import {
  PanelBody,
  ColorPalette,
  __experimentalNumberControl as NumberControl,
} from '@wordpress/components';

const {
  i18n: { __ },
} = wp;

const BackgroundTypeGradient = ({
  backgroundGradientOptions,
  setAttributes,
}) => {
  const colors = wp.data.select('core/block-editor').getSettings().colors;

  const changeAttributeValue = (
    paramValue,
    paramDeviceType,
    paramGradientOptions,
    paramAttributeVariable,
  ) => {
    setAttributes({
      backgroundGradientOptions: {
        ...paramGradientOptions,
        [paramDeviceType]: {
          ...backgroundGradientOptions[paramDeviceType],
          settings: {
            ...paramGradientOptions[paramDeviceType].settings,
            [paramAttributeVariable]: paramValue,
          },
        },
      },
    });
  };

  return (
    <>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <ColorPalette
              label={__('Select Background Color #1', 'b3rg')}
              colors={colors}
              enableAlpha
              value={
                backgroundGradientOptions[deviceType].settings.gradientColorOne
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  backgroundGradientOptions,
                  'gradientColorOne',
                )
              }
            />
            <ColorPalette
              label={__('Select Background Color #2', 'b3rg')}
              colors={colors}
              enableAlpha
              value={
                backgroundGradientOptions[deviceType].settings.gradientColorTwo
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  backgroundGradientOptions,
                  'gradientColorTwo',
                )
              }
            />
            <NumberControl
              label={__('Gradient Direction (Degrees)', 'b3rg')}
              step="any"
              min={0}
              max={360}
              value={
                backgroundGradientOptions[deviceType].settings.gradientDirection
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  backgroundGradientOptions,
                  'gradientDirection',
                )
              }
            />
            <NumberControl
              label={__('Color 1 Location (%)', 'b3rg')}
              step="any"
              min={0}
              max={100}
              value={
                backgroundGradientOptions[deviceType].settings
                  .gradientColorOneLocation
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  backgroundGradientOptions,
                  'gradientColorOneLocation',
                )
              }
            />
            <NumberControl
              label={__('Color 2 Location (%)', 'b3rg')}
              step="any"
              min={0}
              max={100}
              value={
                backgroundGradientOptions[deviceType].settings
                  .gradientColorTwoLocation
              }
              onChange={(newValue) =>
                changeAttributeValue(
                  newValue,
                  deviceType,
                  backgroundGradientOptions,
                  'gradientColorTwoLocation',
                )
              }
            />
          </PanelBody>
        );
      })}
    </>
  );
};

export default BackgroundTypeGradient;
